import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { ButtonLabel, IconButton } from "@similarweb/ui-components";

import { StyledListIconButton } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/ListIconButton/styles";

export const StyledCompanyName = styled.div`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
    ${mixins.truncateText()}
    max-width: 700px;
`;

export const StyledAddWebsiteToListButton = styled.div`
    flex: none;

    &:hover {
        ${StyledListIconButton} {
            background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
        }
    }
`;

export const StyledLinkedinIcon = styled(IconButton)`
    ${SWReactIcons} svg path {
        fill: ${colorsPalettes.carbon[300]};
    }
`;

export const StyledExternalLinkIcon = styled(IconButton)`
    ${SWReactIcons} svg path {
        fill: ${colorsPalettes.carbon[300]};
    }
    ${ButtonLabel} {
        color: ${colorsPalettes.carbon[300]} !important;
    }
    &:hover {
        ${SWReactIcons} svg path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;

export const StyledExternalLink = styled.a`
    margin-left: auto;
    display: block;
`;
